<template>
  <div class="min-h-screen text-white pt-2 md:pt-8">
    <div class="container max-w-screen-lg mx-auto px-4 py-8 h-full">
      <div class="flex items-center gap-4 mb-6">
        <BackToLoginButton v-if="isStandalone" />
        <h1 class="text-2xl md:text-5xl font-bold">
          Get Ready to Level Up with {{ appName }}!
        </h1>
      </div>
      <div class="flex flex-col gap-4 pt-4 md:pt-8">
        <h2 class="text-3xl md:text-4xl font-bold text-center md:text-left">
          Welcome!
        </h2>
        <p class="text-center md:text-left">
          You've just unlocked the door to your ultimate performance. This
          no-sweat setup guide will zoom you straight into the action.
        </p>
        <h2 class="text-3xl font-bold mb-4 text-center md:text-left">
          Let's get started.
        </h2>

        <h3>1. Gear Up & Dive In</h3>
        <p>
          Power up your Meta Quest headset (Quest 2, Quest 3, or Meta Quest
          Pro), or tablet, and let's roll! Download the {{ appName }} app on
          your Meta Quest or tablet, log in with your sign-up details, and
          you're ready to go.
        </p>

        <h3>2. Set Your Winning Mark</h3>
        <p>
          Fire up the app, and we'll walk you through our training tutorials,
          followed by your initial performance assessment. Add about an hour to
          complete the tutorials and assessment or tackle them one section at a
          time. The initial assessment will create your performance baseline and
          you will reassess every 24 completed training sessions. This is where
          your growth begins, with regular check-ins to celebrate your progress!
        </p>

        <h3>3. Train Like a Pro</h3>
        <p>
          Slip on your VR headset or grab your tablet for an epic mix of
          training games that'll hone your skills daily. After nailing your
          session, feel free to hit up to an extra five training games in Open
          Play - it's all part of the fun. Repetition is the name of the game to
          drive improvement so aim for at least three training days a week to
          really see those gains. Got sidetracked or missed sessions? No sweat -
          jump back in when you're ready.
        </p>
        <p>
          You're All Set! Now, go unleash your potential and show us what you've
          got! If you hit a snag or just want to chat, drop us an e-mail at
          support@wetrainyourbrain.com.
        </p>

        <h4 class="text-center md:text-left max-w-xl mx-auto">
          Welcome to the team - where every day, you're one step closer to your
          peak!
        </h4>
      </div>
    </div>
  </div>
</template>

<script setup>
import BackToLoginButton from "@/components/general/BackToLoginButton.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
const route = useRoute();
const store = useStore();

const isStandalone = computed(() => {
  return route.meta.isStandalone;
});

const appName = computed(() => store.getters["location/getAppName"]);
</script>

<style scoped lang="postcss">
h3 {
  @apply text-2xl font-bold;
}

h4 {
  @apply text-xl md:text-3xl font-bold text-center pt-4;
}
</style>
